import React from "react"

const Item6 = () => {
  return (
    <React.Fragment>
      <p className="regular-parraf">Puedes <b className="blue">confiar</b> plenamente en nosotros, ya que somos un curso élite que quiere verte triunfar.</p>
      <p className="regular-parraf">
        El método de pago que seleccionamos fue MercadoPago, ya que con este método, si no estuvieras contento o por alguna extraña razón no se te diera el acceso a la plataforma, puedes solicitar la devolución del 100% de tu dinero directamente con MercadoPago, ellos manejan una política de Programa de Protección al Comprador, para más información,
        <a className="link-blue" href="https://www.mercadopago.com.mx/ayuda/dinero-seguridad-compras_283#programa-proteccion-comprador">clic aquí</a>
      </p>
      <p className="regular-parraf"><b>Hemos ayudado a más de 15 mil Médicos a lograr su objetivo de ser especialistas.</b></p>
    </React.Fragment>
  )
}

export default Item6;